import '../App.css';
import Plus from '../images/plus.png';
import Minus from '../images/minus.png';
import { useState } from 'react';

export default function CartItem({
    book, cart, setCart, totalCost, setTotalCost, totalQty, setTotalQty}) {
    
    let title = book.title;
    let image = book.image;
    let author = book.author;
    let price = book.price;
    
    const [qty, setQty] = useState(book.qty);


    const updateQty = amt => {
        if (qty + amt > 0) {
            setQty(qty + amt);
            book.qty += amt;
            setTotalQty(totalQty + amt);
            setTotalCost(totalCost + (amt * price));
        }
    }
    const removeItem = () => {
        setTotalQty(totalQty - qty);
        setTotalCost(totalCost - (qty * price));
        book.qty = 1;
        setQty(1);
        setCart(cart.filter(item => item !== book));
    }

    return (
        <div className='cart-item'>
            <img src={image} alt={title}/>
            <span className='item-info'>
                <p className='book-title'>{title}</p>
                <p className='book-author'>By {author}</p>
                <p className='book-price'>${price.toFixed(2)}</p>
                <span className='item-qty'>
                    <button className='item-qty-decrease' onClick={() => updateQty(-1)}>
                        <img src={Minus} alt='-' />
                    </button>
                    <p>{qty}</p>
                    <button className='item-qty-increase' onClick={() => updateQty(1)}>
                        <img src={Plus} alt='+' />
                    </button>
                </span>
                <button className='cart-remove-btn' onClick={removeItem}>Remove</button>
            </span>
        </div>
    )

}
